import React, { useContext } from 'react';
import cn from "classnames";
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Typography } from '@mui/material';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import SectionDividers from '@dyl/components/SectionDividers';
import RubricBlock from '@dyl/blocks/RubricBlock';
import TaskRadioImagesBlockForProductiveWriting from '@dyl/blocks/TaskRadioImagesBlockForProductiveWriting';
import TaskContext from '@dyl/pages/Tasks/edit/TaskContext';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: theme.breakpoints.values.md,
  },
  itemHeader: {
    marginBottom: '16px',
  },
  paragraph: {
    marginBottom: theme.spacing(2),
  },
  sectionGap: {
    marginTop: theme.spacing(4),
  },
}));

export default function TaskItems({ className: propsClass, ...other }) {
  const classes = useStyles();
  const [items = []] = useTaskField('items');
  const { lockedState, showSendAutoMarkerButton } = useContext(TaskContext);
  const isDraft = lockedState ?? !!showSendAutoMarkerButton;
  const isArcPublished = !isDraft;
  if (!Array.isArray(items)) return null;
  return (
    <div className={cn(classes.root, propsClass)} {...other}>
      <SectionDividers>
        {items.map((_, i) => (
          <Grid key={i} item xs={12}>
            <Item index={i} isDraft={isDraft} isArcPublished={isArcPublished} />
          </Grid>
        ))}
      </SectionDividers>
    </div>
  );
}

function Item({ index, isDraft, isArcPublished }) {
  const classes = useStyles();

  return (
    <>
      <Typography variant='h6' className={classes.itemHeader}>
        Rubric
      </Typography>
      {index === 0 && <RubricBlock index={index} showSendAutoMarkerButton={isDraft} disabled={!isDraft} />}
      <Typography variant='h6' className={classes.itemHeader}>
        Pictures
      </Typography>

      <Typography> Upload three images for candidates. </Typography>
      <br />
      <Typography> Provide a description for each image for the AI Automarker (ELiT). Use the “Concise” format. End description with appropriate punctuation (.!?). Word count must be between 10-27 per picture. Candidates cannot access the descriptions.</Typography>
      <br />
      <Typography> Refer to this guide <a href="https://btsservice.atlassian.net/wiki/spaces/MR/pages/7257032090/DRAFT+DYL+Flyers+-+Requirements+for+Applied+AI+Writing+Automarking+2025-27#1.-TO-BE%3A--Configuring-for-AI-Automarking" target='_blank' rel="noopener noreferrer"> hyperlink here </a> </Typography>
      <br />
      <TaskRadioImagesBlockForProductiveWriting path={['items', index, 'answers']} hasCheckbox={false} isArcPublished={isDraft} disabled={!isDraft} />
    </>
  );
}